import { render, staticRenderFns } from "./AwardCard.vue?vue&type=template&id=5b59212e&scoped=true"
import script from "./AwardCard.vue?vue&type=script&lang=js"
export * from "./AwardCard.vue?vue&type=script&lang=js"
import style0 from "./AwardCard.vue?vue&type=style&index=0&id=5b59212e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b59212e",
  null
  
)

export default component.exports